/* ===== Mitti Heritage theme JS: announcement rotation + cart drawer ===== */
(function () {
  'use strict';

  /* ---- announcement rotation (5s) ---- */
  var msgs = document.querySelectorAll('.announce .a-msg');
  if (msgs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var idx = 0;
    setInterval(function () {
      msgs[idx].classList.remove('on');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('on');
    }, 5000);
  }

  /* ---- cart drawer ---- */
  var drawer = document.getElementById('MittiDrawer');
  var scrim = document.getElementById('MittiScrim');
  var badge = document.getElementById('MittiCartBadge');
  var FREE_SHIP = (window.MITTI && window.MITTI.freeShipThreshold) || 100;
  var SET_HANDLE = 'discovery-set';
  var money = function (cents) {
    var v = cents / 100;
    return '<span class="pricefig"><span class="cur">$</span>' + (v % 1 === 0 ? v : v.toFixed(2)) + '</span>';
  };

  function renderCart(cart) {
    if (badge) badge.textContent = cart.item_count > 0 ? cart.item_count : '';
    var body = drawer && drawer.querySelector('.drawer-body');
    var foot = drawer && drawer.querySelector('.drawer-foot');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="empty">Your cart is empty, for now.</p>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    var html = '';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_180x$1$2') : '';
      html += '<div class="line">' +
        (img ? '<img src="' + img + '" alt="">' : '<span style="width:60px"></span>') +
        '<div class="line-info"><div class="line-top">' +
        '<a class="line-name" href="' + it.url + '">' + it.product_title + '</a>' +
        '<span class="line-price">' + money(it.final_line_price) + '</span></div>' +
        '<div class="qty" data-key="' + it.key + '">' +
        '<button data-q="' + (it.quantity - 1) + '" aria-label="Decrease"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
        '<span>' + it.quantity + '</span>' +
        '<button data-q="' + (it.quantity + 1) + '" aria-label="Increase"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div></div></div>';
    });
    body.innerHTML = html;

    var subtotal = cart.items_subtotal_price;
    var setOnly = cart.items.length > 0 && cart.items.every(function (it) { return it.handle === SET_HANDLE; });
    var free = subtotal >= FREE_SHIP * 100 || setOnly;
    var note = drawer.querySelector('.ship-note');
    var bar = drawer.querySelector('.ship-bar i');
    var sub = drawer.querySelector('.subtotal .sub-v');
    if (note) note.innerHTML = free ? '<em>Ships free</em>' : "You're <em>$" + Math.ceil((FREE_SHIP * 100 - subtotal) / 100) + '</em> from free U.S. shipping';
    if (bar) bar.style.width = (free ? 100 : Math.min(100, (subtotal / (FREE_SHIP * 100)) * 100)) + '%';
    if (sub) sub.innerHTML = money(subtotal);
  }

  function refresh(open) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      renderCart(c);
      if (open) openDrawer();
      return c;
    });
  }

  function openDrawer() {
    if (drawer) drawer.classList.add('open');
    if (scrim) scrim.classList.add('show');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    if (scrim) scrim.classList.remove('show');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t;
    /* open drawer */
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refresh(true); return; }
    /* close */
    if (e.target.closest('[data-cart-close]') || e.target === scrim) { closeDrawer(); return; }
    /* add to cart */
    t = e.target.closest('[data-add-variant]');
    if (t) {
      e.preventDefault();
      t.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(t.getAttribute('data-add-variant'), 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh(true);
      }).catch(function () {
        window.location.href = t.getAttribute('data-fallback-url') || '/cart';
      }).finally(function () { t.disabled = false; });
      return;
    }
    /* qty change */
    t = e.target.closest('.qty button');
    if (t && drawer && drawer.contains(t)) {
      var key = t.closest('.qty').getAttribute('data-key');
      var q = Math.max(0, parseInt(t.getAttribute('data-q'), 10));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function (r) { return r.json(); }).then(renderCart);
      return;
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* product forms that should use the drawer */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ajax-cart]');
    if (!f) return;
    e.preventDefault();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw 0; return refresh(true); })
      .catch(function () { f.removeAttribute('data-ajax-cart'); f.submit(); });
  });

  refresh(false);
})();
